export default __webpack_public_path__ + "static/media/PurchaseIcon.19a2fd4a.svg";